import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { homeActions } from '../../../store/store';
import { useLocation } from 'react-router-dom';
import { standardizeCaseNumber } from "../../../services/standardize-casenumber";

const Tabs = () => {
  const tabs = [
    'All',
    'Exact Match',
    'Semantic Match',
    'Case Number',
    'Parties',
  ];

  // const selectedTab = useSelector((state) => state.home.selectedOption);
  const _selectedTab = sessionStorage.getItem('searchType');
  const [originalQuery, setOriginalQuery] = useState('');

  const dispatch = useDispatch();
  const location = useLocation();

  // Store the original query when component mounts
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const currentQuery = sessionStorage.getItem('searchedQuery') || 
                        queryParams.get('paralegal[query]');
    
    // Check if we have a stored original query already
    const storedOriginalQuery = sessionStorage.getItem('originalUserQuery');
    
    if (!storedOriginalQuery) {
      // Store the original query without any formatting
      let original = currentQuery;
      if (original && original.startsWith('"') && original.endsWith('"')) {
        original = original.slice(1, -1);
      }
      
      // Save original query to sessionStorage for persistence
      sessionStorage.setItem('originalUserQuery', original);
      setOriginalQuery(original);
    } else {
      setOriginalQuery(storedOriginalQuery);
    }
  }, [location.search]);

  const handleTabClick = (tab) => {
    // Get the previous tab before updating to the new one
    const previousTab = sessionStorage.getItem('searchType');
    
    // Update the tab in state and storage
    dispatch(homeActions.setSelectedOption(tab));
    sessionStorage.setItem('searchType', tab);
    const isEmpty = sessionStorage.getItem('isEmpty');

    if (isEmpty === 'false') {
      // Always use the original unformatted query as our base when switching tabs
      // This ensures we don't compound formatting changes
      let queryToUse = sessionStorage.getItem('originalUserQuery') || originalQuery;
      
      // Special handling when switching FROM Case Number tab
      if (previousTab === 'Case Number' && tab !== 'Case Number') {
        // When leaving the Case Number tab, ensure we use the original query
        console.log("Switching from Case Number tab to", tab, "using original query:", queryToUse);
      }
      
      // Apply tab-specific formatting
      if (tab === 'Exact Match') {
        // Ensure query is wrapped in quotes for Exact Match tab
        newSearch(`"${queryToUse.replace(/"/g, '')}"`);
      } else if (tab === 'Case Number') {
        // Apply case number formatting
        if (queryToUse !== null) {
          // First apply standardization logic for SC cases
          let formattedQuery = standardizeCaseNumber(queryToUse);
          // Then ensure ALL case numbers get hyphenated
          formattedQuery = formattedQuery.replace(/ /g, '-');
          newSearch(formattedQuery);
        }
      } else {
        // For all other tabs, use the original query without quotes
        if (queryToUse && queryToUse.startsWith('"') && queryToUse.endsWith('"')) {
          queryToUse = queryToUse.slice(1, -1);
        }
        newSearch(queryToUse);
      }
    } else {
      // For rendering the state and apply the searchType correctly if user click the searchType as 'All'
      if (tab === 'All') {
        newSearch('');
      }
    }
  };

  const newSearch = (query) => {
    const currentUrl = new URL(window.location.href);
    const params = new URLSearchParams(currentUrl.search);

    params.set('paralegal[query]', query);

    const newUrl = `/search?${params.toString()}`;

    window.location.href = newUrl;
  };

  return (
    <div className="flex items-center gap-5 text-14 text-pl-text-secondary font-medium overflow-x-auto">
      {tabs.map((tab) => (
        <button
          key={tab}
          className={`whitespace-nowrap py-2 px-1 transition-colors duration-150 ${
            _selectedTab === tab
              ? 'font-semibold border-b-2 border-pl-accent text-pl-text-primary'
              : 'hover:text-pl-text-primary'
          }`}
          onClick={() => handleTabClick(tab)}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default Tabs;